/* eslint-disable */

import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import Page from '../../Component/Pagination/Pagination'
import HeaderTable from '../../Component/BaseComponent/HeaderTable'
import cookie from 'react-cookies'
import jMoment from 'moment-jalaali'
import {accounting} from 'accounting'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import RETAIL from '../BaseComponent/RETAIL'
import $ from 'jquery'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import FromToPicker from '../BaseComponent/FromToPicker'
import SearchableCombo from '../BaseComponent/searchableCombo'
import Loader from '../loaders/loader'
class SettlementDrivers extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      settlements: [],
      printInfo: [],
      Drivers: [],
      driverId: '',
      toCreation: '',
      fromCreation: '',
      toSettle: '',
      fromSettle: '',
      aggregate: {}
    }
  }

  getAllSettlements = (
    params = sessionStorage.getItem('params'),
    pageNumber = sessionStorage.getItem('pageNumber'),
    pageSize = sessionStorage.getItem('dropDownVal')
  ) => {
    this.setState({
      loading: true
    })
    return http
      .get(
        `${
          REPORT_DISPATCH.REPORT_DISPATCH_SETTLEMENT
        }?export=false&pageNumber=${pageNumber}&pageSize=${pageSize}&${params}`,
        {}
      )
      .then((response) => {
        this.setState({
          loading: false
        })
        if (response.data.error === null) {
          this.setState({
            settlements: response.data.object.result,
            countAll: response.data.object.countAll
          })
          $('.showBaseTable').fadeIn()
        } else {
          this.setState({
            settlements: [],
            countAll: ''
          })
          $('.showBaseTable').fadeOut()
        }
      })
      .catch(() => {
        this.setState({
          loading: false
        })
      })
  }

  componentDidMount() {
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    sessionStorage.setItem('params', '')

    // this.getAllSettlements()

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })
    http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          var drivers = response.data.object
          for (let i = 0; i < drivers.length; i++) {
            drivers[i]['value'] = drivers[i].personId
            drivers[i]['label'] = drivers[i].personId + ' - ' + drivers[i].name
          }

          this.setState({
            Drivers: response.data.object
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  changeDropDown(data) {
    this.setState({
      settlements: data,
      lengthProducts: this.state.total
    })
  }

  onResultFetched(data) {
    this.setState({
      settlements: data
    })
  }

  exportExcel = () => {
    http
      .get(
        `${REPORT_DISPATCH.REPORT_DISPATCH_SETTLEMENT}?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem(
          'params'
        )}`,
        {}
      )
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            if (excelReport[i]['creationTime'] !== null) {
              excelReport[i]['creationTime'] = jMoment(excelReport[i]['creationTime']).format('jYY/jMM/jDD HH:mm')
              excelReport[i]['settlementTime'] = jMoment(excelReport[i]['settlementTime']).format('jYY/jMM/jDD HH:mm')
            } else {
              excelReport[i]['creationTime'] = ''
            }
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  getPrintInfo = () => {
    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_SETTLEMENT}?export=true&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            printInfo: response.data.object.result
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 landscape;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  getValueDriver = (driverId) => {
    this.setState({
      driverId
    })
  }

  handleChangeFromSettle = (fromSettle) => {
    this.setState({
      fromSettle
    })
  }

  handleChangeToSettle = (toSettle) => {
    this.setState({
      toSettle
    })
  }

  handleChangeFromCreation = (fromCreation) => {
    this.setState({
      fromCreation
    })
  }
  handleChangeToCreation = (toCreation) => {
    this.setState({
      toCreation
    })
  }

  getAggregate = () => {
    return http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_SETTLEMENT}/aggregated?${sessionStorage.getItem('params')}`, {})
      .then((res) => {
        if (res.data.error === null) {
          if (res.data) {
            return res
          }
        }
      })
      .catch(() => {
        this.setState({
          loading: false
        })
      })
  }

  filter() {
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    let fromSettle = this.state.fromSettle
    let toSettle = this.state.toSettle

    // let fromCreation =this.state.fromCreation;
    // let toCreation =this.state.toCreation;
    let driverId = this.state.driverId == null || this.state.driverId == '' ? '' : this.state.driverId.personId

    if (fromSettle === '' && toSettle === '' && driverId === '') {
      message.error('حداقل یک فیلتر وارد شود')
    } else if ((fromSettle != '' || fromSettle == null) && isNaN(fromSettle)) {
      message.error('فرمت تاریخ تسویه ابتدا صحیح نیست')
    } else if ((toSettle != '' || toSettle == null) && isNaN(toSettle)) {
      message.error('فرمت تاریخ تسویه انتها صحیح نیست')
    } else {
      this.setState({
        toPrintDate: fromSettle == '' ? '-' : jMoment(this.state.fromSettle).format('jYY/jMM/jDD'),
        fromPrintDate: toSettle == '' ? '-' : jMoment(this.state.toSettle).format('jYY/jMM/jDD')
      })
      sessionStorage.setItem('params', `driverId=${driverId}&settlementFrom=${fromSettle}&settlementTo=${toSettle}`)
      this.getAllSettlements().then(() => {
        this.setState({
          loading: true
        })
        this.getAggregate().then((res) => {
          this.setState({
            aggregate: res ? res.data.object.result[0] : {},
            loading: false
          })
        })
      })
    }

    // else if((fromCreation!='' || fromCreation==null) && isNaN(fromCreation)){
    //     message.error('فرمت تاریخ ثبت ابتدا صحیح نیست')
    // }
    // else if((toCreation!='' || toCreation==null) && isNaN(toCreation)){
    //     message.error('فرمت تاریخ ثبت انتها صحیح نیست')
    // }
  }

  delete = (driverSettlementId) => {
    let data = {
      driverSettlementId
    }
    if (confirm('آیا از حذف آیتم انتخاب شده مطمئن هستید؟')) {
      http.post(`${RETAIL.RETAIL_COMPANY_SETLLEMENT_DELETE}`, data, {}).then((response) => {
        if (response.data.error === null) {
          this.getAllSettlements()
          message.success('با موفقیت حذف شد')
        } else {
        }
      })
    }
  }

  render() {
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let printCol = [
      'ردیف',
      'رساننده',
      'تاریخ تایید',
      'تاریخ تسویه',
      'کاربر ثبت',
      'بدهکار',
      'تسویه از قبل',
      'پرداخت نقدی',
      'پرداخت با کارتخوان',
      'پرداخت از قبل',
      'مانده',
      'دریافت نقدی',
      'دریافت با کارتخوان'
    ]
    return (
      <div className="rtl printA4Page">
        <Loader show={this.state.loading} />
        <div className="printSection">
          <table className="printTable printReportTable landscapeTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش تسویه رساننده ها"
              headerColSpan={13}
              reporter={cookie.load('name')}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={7}
              rightColSpan={4}
              centerColSpan={2}
              centerSection={''}
              rightSection={
                'تاریخ تسویه از : ' +
                (this.state.toPrintDate === undefined ? '' : this.state.toPrintDate) +
                ' تا ' +
                (this.state.fromPrintDate === undefined ? '' : this.state.fromPrintDate)
              }
              columns={printCol}
            />
            <tbody>
              {this.state.printInfo.map((drivers, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{drivers.driverFirstName + ' ' + drivers.driverLastName}</td>
                  <td>
                    {drivers.creationTime === null ? '-' : jMoment(drivers.creationTime).format('jYY/jM/jD HH:mm')}
                  </td>
                  <td>
                    {drivers.settlementTime === null ? '-' : jMoment(drivers.settlementTime).format('jYY/jM/jD HH:mm')}
                  </td>
                  <td>{drivers.operatorFirstName + ' ' + drivers.operatorLastName}</td>
                  <td className="priceCell">{accounting.formatMoney(drivers.debt, '', ',')}</td>
                  <td className="priceCell">{accounting.formatMoney(drivers.lastSettle, '', ',')}</td>
                  <td className="priceCell">{accounting.formatMoney(drivers.cashPayment, '', ',')}</td>
                  <td className="priceCell">{accounting.formatMoney(drivers.posPayment, '', ',')}</td>
                  <td className="priceCell">{accounting.formatMoney(drivers.otherPayment, '', ',')}</td>
                  <td className="priceCell">{accounting.formatMoney(drivers.remainedPayment, '', ',')}</td>
                  <td className="priceCell">{accounting.formatMoney(drivers.givenCashPayment, '', ',')}</td>
                  <td className="priceCell">{accounting.formatMoney(drivers.givenPosPayment, '', ',')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش تسویه رساننده ها.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'driverFirstName'}
                field={'driverFirstName'}
                title={'نام رساننده'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'driverLastName'}
                field={'driverLastName'}
                title={'نام خانوادگی رساننده'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'creationTime'}
                field={'creationTime'}
                title={'تاریخ ثبت'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'settlementTime'}
                field={'settlementTime'}
                title={'تاریخ تسویه'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'operatorFirstName'}
                field={'operatorFirstName'}
                title={'نام کاربر ثبت'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'operatorLastName'}
                field={'operatorLastName'}
                title={'نام خانوادگی کاربر ثبت'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'givenCashPayment'}
                field={'givenCashPayment'}
                title={'دریافت نقدی'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'givenPosPayment'}
                field={'givenPosPayment'}
                title={'دریافت با کارتخوان'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'debt'}
                field={'debt'}
                title={'بدهکار'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'lastSettle'}
                field={'lastSettle'}
                title={'آخرین تسویه'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'cashPayment'}
                field={'cashPayment'}
                title={'پرداخت نقدی'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'posPayment'}
                field={'posPayment'}
                title={'پرداخت کارتخوان'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'otherPayment'}
                field={'otherPayment'}
                title={'پرداخت از قبل'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'remainedPayment'}
                field={'remainedPayment'}
                title={'مانده'}
                width="200px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>تسویه رساننده</li>
            <li>گزارش تسویه رساننده ها</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl="/financial/settlement"
                  url={REPORT_DISPATCH.REPORT_DISPATCH_SETTLEMENT}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printUrl=""
                  printComponent={this.printTable}
                  execelUrl={REPORT_DISPATCH.REPORT_DISPATCH_SETTLEMENT + '?export=true'}
                  excelColumns={[]}
                  titleAdd="افزودن شهر"
                  printLink=""
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromSettle}
                  onChangeToDate={this.handleChangeToSettle}
                  fromLabel="تاریخ تسویه از"
                  toLabel="تاریخ تسویه تا"
                  defaulValue
                  fromId="fromSettle"
                  toId="toSettle"
                />
                {/*<FromToPicker*/}
                {/*onChangeFromDate={this.handleChangeFromCreation}*/}
                {/*onChangeToDate={this.handleChangeToCreation}*/}
                {/*fromLabel='تاریخ تحویل از'*/}
                {/*toLabel='تاریخ تحویل تا'*/}
                {/*defaulValue={false}*/}
                {/*fromId='fromCreation'*/}
                {/*toId='toCreation'*/}
                {/*/>*/}
                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.Drivers}
                    getValueCombo={this.getValueDriver}
                    lableText="رساننده"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    isDisabled={false}
                  />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>
            {this.state.settlements.length ? (
              <div className="showBaseTable">
                <table className="baseTable">
                  <tbody>
                    <tr className="">
                      <td rowSpan={2}>ردیف</td>
                      <td colSpan={4}>تسویه</td>
                      <td colSpan={6}>در سیستم</td>
                      <td colSpan={3}>تحویلی</td>
                    </tr>
                    <tr className="firstRow">
                      <td>رساننده</td>
                      <td>تاریخ تایید</td>
                      <td>تاریخ تسویه</td>
                      <td>کاربر ثبت</td>
                      <td>بدهکار</td>
                      <td>تسویه از قبل</td>
                      <td>پرداخت نقدی</td>
                      <td>پرداخت کارتخوان</td>
                      <td>پرداخت از قبل</td>
                      <td>مانده</td>
                      <td>دریافت نقدی</td>
                      <td>دریافت با کارتخوان</td>
                      <td>حذف</td>
                    </tr>
                    {this.state.settlements.map((drivers, index) => (
                      <tr key={index}>
                        <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                        <td>{drivers.driverFirstName + ' ' + drivers.driverLastName}</td>
                        <td>
                          {drivers.creationTime === null
                            ? '-'
                            : jMoment(drivers.creationTime).format('jYY/jM/jD HH:mm')}
                        </td>
                        <td>
                          {drivers.settlementTime === null ? '-' : jMoment(drivers.settlementTime).format('jYY/jM/jD')}
                        </td>
                        <td>{drivers.operatorFirstName + ' ' + drivers.operatorLastName}</td>
                        <td className="priceCell">{accounting.formatMoney(drivers.debt, '', ',')}</td>
                        <td className="priceCell">{accounting.formatMoney(drivers.lastSettle, '', ',')}</td>
                        <td className="priceCell">{accounting.formatMoney(drivers.cashPayment, '', ',')}</td>
                        <td className="priceCell">{accounting.formatMoney(drivers.posPayment, '', ',')}</td>
                        <td className="priceCell">{accounting.formatMoney(drivers.otherPayment, '', ',')}</td>
                        <td className="priceCell">{accounting.formatMoney(drivers.remainedPayment, '', ',')}</td>
                        <td className="priceCell">{accounting.formatMoney(drivers.givenCashPayment, '', ',')}</td>
                        <td className="priceCell">{accounting.formatMoney(drivers.givenPosPayment, '', ',')}</td>
                        <td>
                          <button onClick={() => this.delete(drivers.driverSettlementId)}>
                            <img src={require('../../image/trash.svg')} alt={'trash'} />
                          </button>
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td colSpan="5" />
                      <td className="priceCell">{accounting.formatMoney(this.state.aggregate.debtSum, '', ',')}</td>
                      <td className="priceCell">
                        {accounting.formatMoney(this.state.aggregate.lastSettleSum, '', ',')}
                      </td>
                      <td className="priceCell">
                        {accounting.formatMoney(this.state.aggregate.cashPaymentSum, '', ',')}
                      </td>
                      <td className="priceCell">
                        {accounting.formatMoney(this.state.aggregate.posPaymentSum, '', ',')}
                      </td>
                      <td className="priceCell">
                        {accounting.formatMoney(this.state.aggregate.otherPaymentSum, '', ',')}
                      </td>
                      <td className="priceCell">
                        {accounting.formatMoney(this.state.aggregate.remainedPaymentSum, '', ',')}
                      </td>
                      <td className="priceCell">
                        {accounting.formatMoney(this.state.aggregate.givenCashPaymentSum, '', ',')}
                      </td>
                      <td className="priceCell">
                        {accounting.formatMoney(this.state.aggregate.givenPosPaymentSum, '', ',')}
                      </td>
                      <td />
                    </tr>
                  </tbody>
                </table>
                <div className="paginationWrapp">
                  <Page
                    defaultCurrent={1}
                    total={this.state.countAll}
                    urlParams={sessionStorage.getItem('params')}
                    onResultFetched={this.onResultFetched.bind(this)}
                    url={REPORT_DISPATCH.REPORT_DISPATCH_SETTLEMENT}
                  />
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    )
  }
}
export default SettlementDrivers
